import './ValuePropsSectionStyle.less';

import { ScrollEnter } from '@opendoor/bricks';
import * as React from 'react';

export default function() {
  return (
    <section className="od-value-props">
      <div className="regular-container">
        <div className="row">
          <ScrollEnter className="col-xs-12 col-sm-4 text-center value-prop">
            <div className="fade-in-up delay-200ms">
              <img
                src="https://images.opendoor.com/source/s3/imgdrop-production/b316b0620f804793adcbc81d07f9ef1c.svg?service=consumer"
                className="value-prop-icon"
              />
              <h6 className="value-prop-title small-margin-top">Convenient home sale</h6>
              <p className="value-prop-description small-margin-top">
                Sell your home without listing, showings, and months of stress
              </p>
            </div>
          </ScrollEnter>
          <ScrollEnter className="col-xs-12 col-sm-4 text-center value-prop">
            <div className="fade-in-up delay-400ms">
              <img
                src="https://images.opendoor.com/source/s3/imgdrop-production/476e77b0c6004d3b94b69465e2fb4005.svg?service=consumer"
                className="value-prop-icon"
              />
              <h6 className="value-prop-title small-margin-top">Competitive cash offer</h6>
              <p className="value-prop-description small-margin-top">
                No financing fall-through risk, so you can focus on buying your next home
              </p>
            </div>
          </ScrollEnter>
          <ScrollEnter className="col-xs-12 col-sm-4 text-center value-prop">
            <div className="fade-in-up delay-600ms">
              <img
                src="https://images.opendoor.com/source/s3/imgdrop-production/39f7492bae76460abe155db66dc7c293.svg?service=consumer"
                className="value-prop-icon"
              />
              <h6 className="value-prop-title small-margin-top">Move on your timeline</h6>
              <p className="value-prop-description small-margin-top">
                Complete flexibility and control of your moving timeline
              </p>
            </div>
          </ScrollEnter>
        </div>
      </div>
    </section>
  );
}
